import { Loader2 } from "lucide-react";
import { fmtMoney } from "../../lib/money";

type ExcessRow = {
  id: string;
  name: string;
  reason?: string | null;
  value?: number;
};

function moneyOf(row: ExcessRow): number | null {
  return "value" in row && typeof row.value === "number" ? row.value : null;
}

// The sum is only the fields that have a figure. A total that quietly omits fields is a
// number someone would hand onward and misread, so the count is on the line.
export function Section180ExcessList(props: {
  prepping: boolean;
  showReading: boolean;
  rows: ExcessRow[];
}) {
  const { prepping, showReading, rows } = props;
  const priced = rows.flatMap((row) => {
    const value = moneyOf(row);
    return value == null ? [] : [value];
  });
  const excessTotal = priced.reduce((acc, value) => acc + value, 0);
  return (
    <div className="border-t border-line px-4 py-3">
      <div className="mb-2 flex flex-wrap items-baseline gap-x-2 gap-y-1">
        <span className="text-[12px] font-semibold text-fg">
          Total Excess Fertility by Field
        </span>
        <span className="text-[10px] text-faint">
          ROGO&rsquo;s published market for each field&rsquo;s own state
        </span>
        {prepping && <Loader2 size={11} className="animate-spin text-accent" />}
      </div>
      {showReading ? (
        <p className="text-[11px] text-muted">
          Reading each field&rsquo;s current samples…
        </p>
      ) : (
        <ul className="divide-y divide-line/60">
          {rows.map((r) => {
            const value = moneyOf(r);
            return (
              <li
                key={r.id}
                className="flex items-baseline justify-between gap-3 py-1"
              >
                <span
                  className="min-w-0 truncate text-[12px] text-fg"
                  title={r.name}
                >
                  {r.name}
                </span>
                {value != null ? (
                  <span className="tnum shrink-0 text-[12px] font-medium text-fg">
                    {fmtMoney(value)}
                  </span>
                ) : (
                  <span className="shrink-0 text-[11px] text-muted">
                    {r.reason ?? "—"}
                  </span>
                )}
              </li>
            );
          })}
          {priced.length > 1 && (
            <li className="flex items-baseline justify-between gap-3 border-t border-line pt-1.5">
              <span className="text-[12px] font-semibold text-fg">
                Total
                {priced.length < rows.length
                  ? ` (${priced.length} of ${rows.length} fields)`
                  : ""}
              </span>
              <span className="tnum shrink-0 text-[12px] font-semibold text-fg">
                {fmtMoney(Math.round(excessTotal * 100) / 100)}
              </span>
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
